// extracted by mini-css-extract-plugin
module.exports = {"list":"CheckboxList_list__r1VH_ containerScrollbar"};